import Vue from 'vue';
import qs from 'querystring';
import { getApp } from '@/utils/util';

/**
 * 通过远程配置scheme调用终端方法
 * @param {String} scheme 链接。格式为 tgchippy://callNativeWithPromise?methodName=[methodName]&params=[params]
 * @example
 * ```js
 * callNativeWithPromiseByScheme('tgchippy://callNativeWithPromise?methodName=showPostDialog')
 * ```
 */
export function callNativeWithPromiseByScheme(scheme) {
  const VALID_SCHEME_REGEXP = /^tgchippy:\/\/([a-zA-Z0-9]+)\?(.+)/;
  const result = VALID_SCHEME_REGEXP.exec(scheme);
  if (!result) {
    throw Error('callNativeWithPromiseByScheme scheme错误');
  }

  const [,, querystring] = result;
  const { methodName, params: paramsStr } = qs.parse(querystring);
  const params = paramsStr ? JSON.parse(paramsStr) : {};
  console.log('callNativeWithPromiseByScheme', methodName, params);
  return callNativeWithPromise('GameCommunityJsModule', methodName, getApp().$options.rootViewId, params);
}

export function callNativeWithPromise(moduleName, methodName, ...params) {
  return Vue.Native.callNativeWithPromise(
    'GameCommunityJsModule',
    methodName,
    ...params,
  );
}

export function callNative(moduleName, methodName, ...params) {
  if (methodName === 'callNativeAction') {
    return Vue.Native.callNative(
      'GameCommunityJsModule',
      methodName,
      getApp().$options.rootViewId,
      ...params,
    );
  }
  return Vue.Native.callNative(
    'GameCommunityJsModule',
    methodName,
    ...params,
  );
}

/**
 * 可以多次回调的方法
 */
export function callNativeWithCallbackId(methodName, callback, instanceId, params) {
  if (typeof callback !== 'function') {
    throw new TypeError('first argument must be function');
  }
  if (Vue.Native.Platform === 'ios') {
    return Vue.Native.callNativeWithCallbackId(
      'GameCommunityJsModule',
      methodName,
      false,
      instanceId,
      params,
      callback,
    );
  }
  return Vue.Native.callNativeWithCallbackId(
    'GameCommunityJsModule',
    methodName,
    false, // 是否自动删除
    callback,
    instanceId,
    params,
  );
}
